// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/jepx_member_info_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { JepxFeeSchedule, JepxMemberInfo } from "./jepx_member_info_model_pb";
import { file_bffuser_v1_jepx_member_info_model } from "./jepx_member_info_model_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/jepx_member_info_service.proto.
 */
export const file_bffuser_v1_jepx_member_info_service: GenFile = /*@__PURE__*/
  fileDesc("CiliZmZ1c2VyL3YxL2plcHhfbWVtYmVyX2luZm9fc2VydmljZS5wcm90bxIKYmZmdXNlci52MSIaChhHZXRKZXB4TWVtYmVySW5mb1JlcXVlc3QifwoZR2V0SmVweE1lbWJlckluZm9SZXNwb25zZRIvCgttZW1iZXJfaW5mbxgBIAEoCzIaLmJmZnVzZXIudjEuSmVweE1lbWJlckluZm8SMQoMZmVlX3NjaGVkdWxlGAIgASgLMhsuYmZmdXNlci52MS5KZXB4RmVlU2NoZWR1bGUyeQoVSmVweE1lbWJlckluZm9TZXJ2aWNlEmAKEUdldEplcHhNZW1iZXJJbmZvEiQuYmZmdXNlci52MS5HZXRKZXB4TWVtYmVySW5mb1JlcXVlc3QaJS5iZmZ1c2VyLnYxLkdldEplcHhNZW1iZXJJbmZvUmVzcG9uc2VCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bffuser_v1_jepx_member_info_model]);

/**
 * @generated from message bffuser.v1.GetJepxMemberInfoRequest
 */
export type GetJepxMemberInfoRequest = Message<"bffuser.v1.GetJepxMemberInfoRequest"> & {
};

/**
 * Describes the message bffuser.v1.GetJepxMemberInfoRequest.
 * Use `create(GetJepxMemberInfoRequestSchema)` to create a new message.
 */
export const GetJepxMemberInfoRequestSchema: GenMessage<GetJepxMemberInfoRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_member_info_service, 0);

/**
 * @generated from message bffuser.v1.GetJepxMemberInfoResponse
 */
export type GetJepxMemberInfoResponse = Message<"bffuser.v1.GetJepxMemberInfoResponse"> & {
  /**
   * Unset when the organization has no JEPX 会員ID registered (= 未設定).
   *
   * @generated from field: bffuser.v1.JepxMemberInfo member_info = 1;
   */
  memberInfo?: JepxMemberInfo;

  /**
   * JEPX 参加料規程に基づく料金・手数料。 常に返る。
   *
   * @generated from field: bffuser.v1.JepxFeeSchedule fee_schedule = 2;
   */
  feeSchedule?: JepxFeeSchedule;
};

/**
 * Describes the message bffuser.v1.GetJepxMemberInfoResponse.
 * Use `create(GetJepxMemberInfoResponseSchema)` to create a new message.
 */
export const GetJepxMemberInfoResponseSchema: GenMessage<GetJepxMemberInfoResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_jepx_member_info_service, 1);

/**
 * JepxMemberInfoService exposes the JEPX 連携マスタ情報 (会員情報 + 料金・手数料)
 * to the frontend. Thin pass-through over internalapi.v1.JepxMemberInfoService.
 *
 * 読み取り専用。 登録・変更は運営側オペレーション (dev-tool) の責務のため、
 * 本 service には mutation RPC を置かない (AC-IJM-002 / AC-IJM-008)。
 *
 * @generated from service bffuser.v1.JepxMemberInfoService
 */
export const JepxMemberInfoService: GenService<{
  /**
   * GetJepxMemberInfo returns the organization's JEPX 連携マスタ情報.
   * member_info is unset when 未設定 (= the frontend renders the empty state
   * per AC-IJM-003)。 fee_schedule is always populated.
   *
   * @generated from rpc bffuser.v1.JepxMemberInfoService.GetJepxMemberInfo
   */
  getJepxMemberInfo: {
    methodKind: "unary";
    input: typeof GetJepxMemberInfoRequestSchema;
    output: typeof GetJepxMemberInfoResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_jepx_member_info_service, 0);

